import React from 'react'
import { render } from 'react-dom'
import './assets/index.scss'

import App from './App'

const root = document.getElementById('app')

render(<App />, root)
